import moment from 'moment';

const getDefaultChartData = () => {
  const start = moment().startOf('day').subtract(10, 'days');

  const events = Array.from({ length: 11 }, () => ({
    action: 'view',
    date: start.add(1, 'days').toISOString(),
    count: 0
  }));

  return [{ events }];
};

export default getDefaultChartData;
